var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7577 11.5812C20.5694 11.5666 20.3819 11.5431 20.1958 11.5112C18.1561 11.1518 16.435 9.78821 15.6187 7.88475L13.9769 17.1957C13.3067 20.9964 9.68248 23.5342 5.8818 22.864C2.08112 22.1939 -0.456745 18.5696 0.213397 14.769C0.883539 10.9684 4.50783 8.43054 8.3085 9.1007C8.45222 9.12605 8.59028 9.16367 8.72998 9.19753L8.13204 12.5886C7.99375 12.5468 7.85959 12.4966 7.71424 12.4709C5.77445 12.1289 3.92468 13.4241 3.58264 15.3639C3.2406 17.3037 4.53582 19.1535 6.47561 19.4955C8.41581 19.8377 10.3986 18.6112 10.7407 16.6711L13.5629 0.863601L16.8073 1.43567C16.6002 4.39897 18.5454 7.08517 21.4253 7.81287L20.7608 11.5818",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f49491eb53147b8a5cb1b981587ed894.svg";
export { ForwardRef as ReactComponent };